import ajax from '@/utils/ajax'

/**
 * @module POS订单列表
 */

// 查询订单列表
export const queryOrderList = params => ajax.post('order/queryPosOrdersList', params)

// 查询总金额
export const getSum = params => ajax.post('order/getPosOrderSummary', params)
 
// 提交退款
export const submitRefund = params => ajax.post('order/applyPosOrderRefund', params)

// 补打小票
export const makeSmallTicket = params => ajax.post('order/printPosOrderTicket', params)

// 导出数据
export const exportData = params => ajax.post('order/exportPosOrdersExcel', params)

// 获取订单查询所需订单状态
export const getQueryOrderType = params => ajax.post('order/getPosOrderStatus', params)

// 获取订单查询所需油站列表
export const getQueryGasList = params => ajax.post('gasInfo/getAllGasInfoList', params)

// 获取订单查询所需油号列表
export const getOilNumList = params => ajax.get('/gasInfo/getAllOilNumList', params)

// 获取订单详情
export const getOrderDetail = params => ajax.post('order/getPosOrderDetail', params)

